import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

let initialState = {
  orders: {
    type: "",
    userId: "",
    orderDetails: [],
    address: "",
    priceType: "",
    points: 0,
    curentOrderPoints: 0,
    courier: 0,
    gst: false,
    courierType: "",
  },
};

export const orderReducer = createSlice({
  name: "order",
  initialState,
  reducers: {
    update: (state, action) => {
      state.orders = { ...state.orders, ...action.payload };
    },
    destore: (state, action) => {
      state.orders = initialState.orders;
    },
    updateDiscountAmount: (state, action) => {
      state.orders.orderDetails[action.payload.index].totalDiscountAmount =
        action.payload.total;
    },
  },
});

// Action creators are generated for each case reducer function
export const { update, destore, updateDiscountAmount } = orderReducer.actions;

export default orderReducer.reducer;
